import Bugsnag, { BrowserConfig } from '@bugsnag/js';
import getConfig from 'next/config';
const config = getConfig();

/**
 * Returns restricted Bugsnag options unless the user has consented to statistics tracking
 */
const getConsentBasedOptions = (): Partial<BrowserConfig> => {
  const isBrowserContext = typeof window !== 'undefined';
  const hasCookiebot = isBrowserContext && typeof window.Cookiebot !== 'undefined';

  if (hasCookiebot && window.Cookiebot.consent.statistics) {
    return {};
  }

  return {
    collectUserIp: false,
    generateAnonymousId: false,
    autoTrackSessions: false,
    enabledBreadcrumbTypes: ['error'],
    onError: (event) => {
      if (event.request?.url) {
        // Sanitizes the request URL of any potentially sensitive query strings
        const url = new URL(event.request.url);
        event.request.url = url.origin + url.pathname;
      }
    },
  };
};

Bugsnag.start({
  apiKey: config
    ? config.serverRuntimeConfig.BUGSNAG_API_KEY || config.publicRuntimeConfig.BUGSNAG_API_KEY
    : process.env.BUGSNAG_CLIENT_API_KEY,
  releaseStage: config.publicRuntimeConfig.ENVIRONMENT,
  enabledReleaseStages: ['qa', 'stage', 'production'],
  ...(config.publicRuntimeConfig.ENVIRONMENT === 'local' && { logger: null }),
  ...getConsentBasedOptions(),
});
